import React from 'react';
import Modal from '../modal.js';
import TemperatureReport from './TemperatureReport.js';

module.exports = React.createClass({
    success: function(reply) {
        if (reply.data.link.toLowerCase() === this.state.link) {
            this.setState({reportData: reply.data});
            if (this.props.gotReport)
                this.props.gotReport(reply.data);
        }
    },
    getInitialState: function() {
        return {
            reportData: null,
            link: null
        }
    },
    loadReportFromServer: function(link) {
        if (link) {
            this.state.link = link;
            HC_SendRequest("report", {link: link}, this.success, null);
        }
    },
    componentWillMount: function() {
        this.mountState = true;
        this.loadReportFromServer(this.props.link);
    },
    componentWillUnmount() {
        this.mountState = false;
    },
    componentWillReceiveProps(newProps) {
        if (this.state.link !== newProps.link)
            this.loadReportFromServer(newProps.link);
    },
    showComment: function(o) {
        o.preventDefault();

        var comment = o.target.getAttribute('data-comment');
        var filePath = o.target.getAttribute('data-file-path');
        var fileName = o.target.getAttribute('data-file-name');
        let downloadLinkedFile = () => HC_DownloadFile(filePath, fileName);
        var commentFrame = React.createClass({
            render: function () {
                return (
                    <Modal data-style={this.props['data-style']}>
                        <div className='modal-body' style={{marginTop: "2.5rem"}}>
                            <div className="hc-f2" style={{textAlign:"center", wordWrap:"break-word"}}>{comment}</div>
                            <span className="hc-f4 hc-f-l hc-gray-hover"
                               onClick={downloadLinkedFile}
                               style={{display:'block', padding:'10px', textAlign:"center", textDecoration: "underline", cursor: "pointer"}}>
                                {fileName}
                           </span>

                            <div className='text-right' style={{marginTop: "1rem", marginBottom: "2rem", textAlign:"center"}}>
                                <button type='button' className='hc-button' onClick={HC_CloseModal}>OK</button>
                            </div>
                        </div>
                    </Modal>
                );
            }
        });
        HC_ShowModal(commentFrame, null);
    },
    generateReportItemView: function(reportItem, i) {
        var report = this.state.reportData;
        var period;
        if (!report.to_date) {
            if (report.days)
                period = HC_LANG.CHL_LATEST + " " + report.days + " " + HC_LANG.CHL_DAYS;
        } else {
            var dateTo = new Date(report.to_date);
            var dateFrom = new Date(dateTo.getTime() - (report.days-1) * 86400000);
            period = HC_FormatShortDate(dateFrom) + ' - ' + HC_FormatShortDate(dateTo) + ' (' + report.days + ' ' + HC_LANG.CHL_DAYS + ')';
        }

        var firstLine = null;
        var lastLine = (
            <table className="table" style={{tableLayout: 'fixed'}}>
                <tbody>
                    <tr className="hc-bt"><td></td></tr>
                </tbody>
            </table>
        );

        var content;
        if (reportItem.periods.length === 0 || (reportItem.manual_state != 0 && reportItem.report_type === HC_CONST.REPORT_NOT_FILLED)) {
            var contentString;
            if (reportItem.manual_state != 0 && reportItem.report_type === HC_CONST.REPORT_NOT_FILLED)
                contentString = HC_LANG.REP_LAUNCH_NOT_FILL;
            else
            {
                contentString = reportItem.report_type === HC_CONST.REPORT_NOT_FILLED
                    ? HC_LANG.REP_ALL_FILLED_PERIOD
                    : HC_LANG.REP_NO_DATA_PERIOD;
            }
            content = (<div className="hc-f4 hc-f-l" style={{textAlign:'center', marginTop:'20px'}}>{contentString}</div>);
            firstLine = lastLine;
            lastLine = null;
        }
        else if (reportItem.report_type === HC_CONST.REPORT_OVERVIEW)
            content = this.GenerateOverviewConetent(report, reportItem);
        else if (reportItem.report_type === HC_CONST.REPORT_ERRORS || reportItem.report_type === HC_CONST.REPORT_ALL_INPUT)
            content = this.GenerateAllInputConetent(report, reportItem, reportItem.report_type === HC_CONST.REPORT_ERRORS);
        else if (reportItem.report_type === HC_CONST.REPORT_NOT_FILLED)
            content = this.GenerateNotFilledConetent(report, reportItem);

        var counts, relErrors, relCheckedAndErrors, checkedAndErrArc, errorArc, percentChecked, percentErrors, circle;
        if (reportItem.report_type !== HC_CONST.REPORT_NOT_FILLED) {
            if (reportItem.manual_state != 0)
                reportItem.all_count = reportItem.errors_count + reportItem.checked_count;
            if (reportItem.errors_count + reportItem.checked_count !== 0) {
                relErrors = reportItem.errors_count * 359.99 / (reportItem.all_count);
                relCheckedAndErrors = (reportItem.errors_count + reportItem.checked_count) * 359.99 / (reportItem.all_count);

                if (relCheckedAndErrors > 325 && reportItem.errors_count + reportItem.checked_count < reportItem.all_count) {
                    relErrors -= relCheckedAndErrors - 325;
                    relCheckedAndErrors = 325;
                }

                if (relErrors > 300 && reportItem.checked_count > 0)
                    relErrors = 300;

                if (relCheckedAndErrors < 10) {
                    relCheckedAndErrors += 10;
                    relErrors += 10;
                }

                if (relCheckedAndErrors - relErrors < 10 && reportItem.errors_count > 0)
                    relCheckedAndErrors += 10;

                percentErrors = Math.round(reportItem.errors_count * 100 / (reportItem.all_count)).toString() + '%';
                percentChecked = Math.round(reportItem.checked_count * 100 / (reportItem.all_count)).toString() + '%';

                if (percentErrors === '0%' && reportItem.errors_count > 0)
                    percentErrors = '<1%';

                if (percentChecked === '0%' && reportItem.checked_count > 0)
                    percentChecked = '<1%';
            } else {
                relErrors = 0;
                percentChecked = percentErrors = '0%';
            }
            if (reportItem.checked_count > 0 && reportItem.report_type !== HC_CONST.REPORT_ERRORS) {
                checkedAndErrArc = (<g fill="none" stroke="#30ae97" strokeWidth="18">
                    <path id='arc2' strokeLinecap="round" d={this.describeArc(70, 75, 60, 0, relCheckedAndErrors)}/>
                </g>);
            }
            if (reportItem.errors_count > 0) {
                errorArc = (<g fill="none" stroke="#ff5555" strokeWidth="18">
                    <path id='arc2' strokeLinecap="round" d={this.describeArc(70, 75, 60, 0, relErrors)}/>
                </g>);
            }
            if (reportItem.report_type === HC_CONST.REPORT_ERRORS)
                percentChecked = "";

            circle = (<svg height="150" width="150" style={{display:'inline-block'}}>
                <g fill="none" stroke='#EAEFEE' strokeWidth="18">
                    <path id='arc0' strokeLinecap="round" d={this.describeArc(70, 75, 60, 0, 359.99)}/>
                </g>
                {checkedAndErrArc}
                {errorArc}
                <text x="110" y="10"
                      fontFamily="Verdana"
                      fontSize="12"
                      fill="#ff5555">
                    {percentErrors}
                </text>
                <text x="0" y="145"
                      fontFamily="Verdana"
                      fontSize="12"
                      fill="#30ae97">
                    {percentChecked}
                </text>
            </svg> );

            var checked = null;
            if (reportItem.report_type !== HC_CONST.REPORT_ERRORS) {
                checked = (<div
                    style={{display:'inline-block', border:"solid 1px rgba(48, 174, 150, 0.3)", textAlign:'center', height:'40px', width:'47%', marginRight:'4.9%', overflow:'hidden'}}>
                    <span className="hc-f1"
                          style={{color: "#30ae97 !important", textAlign:"center"}}>{reportItem.checked_count}</span>
                    <span className="hc-f6"
                          style={{paddingLeft:'5px', color: "#30ae97 !important", whiteSpace:'nowrap', textTransform: "uppercase"}}>{HC_LANG.REP_CHECKED}
                    </span>
                </div>);
            }
            counts = (<div style={{verticalAlign:'top', width:'100%'}}>
                {checked}
                <div
                    style={{display:'inline-block', border:"solid 1px rgba(255, 84, 84, 0.3)", textAlign:'center', height:'40px', width:(checked ? '47%' : '100%'), overflow:'hidden'}}>
                    <span className="hc-f1"
                         style={{color: "#ff5555 !important"}}>{reportItem.errors_count}</span>
                    <span className="hc-f6"
                          style={{paddingLeft:'5px', color: "#ff5555 !important", whiteSpace:'nowrap', textTransform: "uppercase"}}>{HC_LANG.REP_ERRS}
                    </span>
                </div>
            </div>);
        }
        var tz = report.tz_offset / (-60);
        var timeZone = "UTC" + (tz > 0 ? "+" : "") + (tz == 0 ? "" : tz);

        var infoMarginRight = '160px';
        if (reportItem.report_type === HC_CONST.REPORT_NOT_FILLED)
            infoMarginRight = 0;

        return (
            <div key={i++} style={{marginBottom:'4rem'}}>
                <div style={{display:'inline-block', position:'relative', width:'100%', marginTop:'10px', marginBottom:'10px'}}>
                    <div
                        style={{display:'inline-block', verticalAlign:'top', marginTop:'1rem', marginRight:infoMarginRight}}>
                        <div className="hc-f2">{reportItem.name}</div>
                        <div className="hc-f4 hc-f-l">{ HC_LANG.CHL_CAPTION + ": " + reportItem.checklist_name}</div>
                        <div
                            className="hc-f4 hc-f-l">{ HC_LANG.REP_REP_TYPE + ": " + HC_GetReportType(reportItem.report_type)}</div>
                        <div className="hc-f4 hc-f-l">{ HC_LANG.REP_REP_PERIOD + ": " + period}</div>
                        <div
                            className="hc-f4 hc-f-l">{ HC_LANG.DUE_FILL_IN + ": " + (reportItem.manual_state == 0 ? HC_GetFillInStr(reportItem.fill_in) : HC_LANG.CHL_MANUALLY)}</div>
                        <div
                            className="hc-f4 hc-f-l">{ HC_LANG.DUE_ERR_ALLOW + ": " + reportItem.errors_allowed + HC_GetErrorsPeriod(reportItem.errors_period)}</div>
                        <div className="hc-f4 hc-f-l">{ HC_LANG.REP_TYPE_ZONE + ": " + timeZone}</div>
                    </div>
                    <div key="1" style={{display:'inline-block', top:0, right:0,  position:'absolute'}}>
                        {circle}
                    </div>
                </div>
                {counts}
                {firstLine}
                {content}
                {lastLine}
            </div>
        );
    },
    GenerateOverviewConetent: function(report, reportItem) {
        var firstLine = 0, i = 0;
         return reportItem.periods.map(function(o){
             var j = 0;
            var itemsContent = o.items.map(function(item) {
                var textClassName = "hc-f4 " + (item.e > reportItem.errors_allowed ? 'hc-red' : 'hc-f-l');
                return (<tr key={j++} style={{tableLayout: 'fixed'}}>
                    <td className={textClassName} style={{paddingLeft:'5%', width:'45%', overflowWrap: "break-word", border:'none', verticalAlign:'initial !important'}}>{item.i}</td>
                    <td className={textClassName} style={{paddingLeft:'5%', width:'45%', overflowWrap: "break-word", border:'none', verticalAlign:'initial !important'}}>{item.a}</td>
                    <td className={textClassName} style={{textAlign:'right', width:'10%', border:'none', verticalAlign:'initial !important'}}>{item.e}</td>
                </tr>);
            });
            return (
                <div key={i++}>
                    <table className="table hc-f4" style={{width:"100%", margin:0, tableLayout: 'fixed'}}>
                        <tbody>
                        <tr style={{height:'4rem'}}>
                            <td className="hc-f3 hc-gray hc-bb" style={firstLine++ === 0 ? {borderTop:'none'} : {}}>{o.title}</td>
                        </tr>
                        </tbody>
                    </table>
                    <table className="table hc-f4" style={{tableLayout: 'fixed', margin:0}}>
                        <tbody>
                        {itemsContent}
                        </tbody>
                    </table>
                </div>
            );
        });
    },
    GenerateAllInputConetent: function(report, reportItem, onlyErrors) {
        var firstLine = 0, i = 0;
        return reportItem.periods.map(function(o){
            var j = 0;
            var dates = o.items.map(function(d) {
                var comment;
                if (d.comment) {
                    comment = (<i className={"fa hc-fa-action hc-hover " + (d.file_path ? "fa-file-o" : "fa-comment")} style={{fontSize: '1rem', cursor:'pointer'}}
                              data-comment={d.comment} data-file-name={d.file_name} data-file-path={d.file_path} onClick={this.showComment}/>);
                }
                var cross;
                if (!onlyErrors) {
                    cross = (<div className="fa hc-red fa-times" style={{display:'inline-block', opacity:d.error?0:1, fontSize: '1rem', paddingRight:'0.5rem', position:'relative', top:'1px'}}/>);
                }
                var textClassName = 'hc-f4';
                var errorTextClassName =  'hc-f4 hc-red';
                var w = $(window).width();
                var smallReport = (w < 500 || (w > 735 && w < 900));
                var date = (<td style={{paddingLeft:0, paddingRight:0, paddingTop:'9px', width:'63px', overflowWrap: "break-word", border:'none', verticalAlign:'initial !important', position:'relative'}}>
                    {cross}
                    <div className={d.error ? textClassName : errorTextClassName}
                         style={{display:'inline-block', position:'relative', top:'1px'}}>{d.date}</div>
                </td>);
                var by = (<td className={d.error ? textClassName : errorTextClassName} style={{textAlign:'right', width:'35%', overflowWrap: "break-word", border:'none', verticalAlign:'initial !important', paddingLeft:0}}>{d.by}</td>);
                var icon = (<td style={{textAlign:'center', width:'20px', padding:0, overflowWrap: "break-word", border:'none', verticalAlign:'initial !important'}}>{comment}</td>);
                if (smallReport) {
                    return (
                        <tr key={++j}>
                            {date}
                            <td className={d.error ? textClassName : errorTextClassName} style={{paddingLeft:'4%', paddingRight:'5px', width:'65%', overflowWrap: "break-word", border:'none', verticalAlign:'initial !important'}}>
                                <div>{d.item}</div>
                                <div>{d.action}</div>
                            </td>
                            {by}
                            {icon}
                        </tr>
                    );
                } else {
                    return (
                        <tr key={++j}>
                            {date}
                            <td className={d.error ? textClassName : errorTextClassName}
                                style={{paddingLeft:'8%', width:'40%', overflowWrap: "break-word", border:'none', verticalAlign:'initial !important'}}>{d.item}</td>
                            <td className={d.error ? textClassName : errorTextClassName}
                                style={{paddingLeft:'3%', width:'40%', overflowWrap: "break-word", border:'none', verticalAlign:'initial !important'}}>{d.action}</td>
                            {by}
                            {icon}
                        </tr>
                    );
                }
            }.bind(this));
            return (
                <div key={i++}>
                    <table className="table hc-f4" style={{width:"100%", margin:0, tableLayout: 'fixed'}}>
                        <tbody>
                        <tr style={{height:'4rem'}}>
                            <td className="hc-f3 hc-gray hc-bb" style={firstLine++ === 0 ? {borderTop:'none'} : {}}>{o.title}</td>
                        </tr>
                        </tbody>
                    </table>
                    <table className="table hc-f4" style={{tableLayout: 'fixed', margin:0}}>
                        <tbody>
                        {dates}
                        </tbody>
                    </table>
                </div>
            );
        }.bind(this));
    },
    GenerateNotFilledConetent: function(report, reportItem) {
        var firstLine = 0, i = 0;
        var period;
        if (reportItem.fill_period == 0)
            period = '12h';
        else if (reportItem.fill_period == 1)
            period = '24h';
        else if (reportItem.fill_period == 2)
            period = 'Week';
        else if (reportItem.fill_period == 3)
            period = 'Month';
        return reportItem.periods.map(function(o){
            var j = 0;
            var dates = o.dates.map(function(d) {
                return (
                    <tr key={j++}>
                        <td className="hc-flex-display" style={{display:'flex',  justifyContent: 'space-between', WebkitJustifyContent:'space-between'}}>
                            <span style={{flex: '0 0 auto', alignSelf: 'flex-start', WebkitAlignSelf:'flex-start', WebkitFlex:'0 0 auto'}}>
                                <i className="fa fa-warning" style={{color:'#ffa400', fontSize: '1rem', paddingRight:'0.5rem'}}/>
                                {d[0]}
                            </span>
                            <span style={{flex: '0 0 auto', alignSelf: 'center', WebkitAlignSelf:'center', WebkitFlex:'0 0 auto'}}>{period}</span>
                            <span style={{flex: '0 0 auto', alignSelf: 'flex-end', WebkitAlignSelf:'flex-end', WebkitFlex:'0 0 auto'}}>{d[1]}</span>
                        </td>
                    </tr>
                );
            });
            //<td>Not filled in between {start} and {end}</td>
            return (
                <div key={i++}>
                    <table className="table hc-f4" style={{width:"100%", margin:0, tableLayout: 'fixed'}}>
                        <tbody>
                        <tr style={{height:'4rem'}}>
                            <td className="hc-f3 hc-gray hc-bb" style={firstLine++ === 0 ? {borderTop:'none'} : {}}>{o.title}</td>
                        </tr>
                        </tbody>
                    </table>
                    <table className="table hc-f4" style={{tableLayout: 'fixed', margin:0}}>
                        <tbody>
                            {dates}
                        </tbody>
                    </table>
                </div>
            );
        });
    },
    polarToCartesian: function(centerX, centerY, radius, angleInDegrees) {
        var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;
        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    },
    describeArc: function(x, y, radius, startAngle, endAngle) {
        var start = this.polarToCartesian(x, y, radius, endAngle);
        var end = this.polarToCartesian(x, y, radius, startAngle);
        var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
        var d = [
            "M", start.x, start.y,
            "A", radius, radius, 0, arcSweep, 0, end.x, end.y
        ].join(" ");
        return d;
    },
    render: function() {
        if (!this.state.reportData)
            return (<div className="loader"/>);

        let i = 0;
        let reportItems = this.state.reportData.report_items.map(function (reportItem) {
            if (reportItem.checklist_type == HC_CONST.CL_TYPE_TEMP)
                return <TemperatureReport key={i++} item={reportItem}/>;
            return this.generateReportItemView(reportItem, i++);
        }.bind(this));

        return (
            <div style={{maxWidth: '590px', margin:'auto', padding:'1.5rem'}}>
                {reportItems}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./reports/ReportContent.js